import React from 'react';
import { MealDashboard } from '../components/food/mealDashboard';
import { Header } from '../components/global/header';
import { Footer } from '../components/global/footer';

export function MealDashboardPage() {
  return (
    <div>
      <Header />
      <MealDashboard />
      <Footer />
    </div>
  );
}

export default MealDashboardPage;
